<template>
<ItpBox
  alignItems="center"
>
  <DIV
    :style="b_2248226175642056_style"
  >
    <ItpBox
      class="mb-2"
    >
      <ItpText
        strong
        :text="fixedAsset.rental.name"
        no-wrap
        v-if="fixedAsset.rental"
      >
      </ItpText>
      <ItpLink
        :to="{
    name: 'app.rental',
    params: { id: fixedAsset.rental.id }
  }"
        icon="fa-external-link-square-alt"
        class="ml-2"
        v-if="fixedAsset.rental"
      >
      </ItpLink>
    </ItpBox>
    <ItpBox
      class="mb-2"
    >
      <ItpText
        strong
        :text="fixedAsset.rental.client_name"
        no-wrap
        v-if="fixedAsset.rental && fixedAsset.rental.client_id"
      >
      </ItpText>
      <ItpLink
        :to="{
    name: 'app.company',
    params: { id: fixedAsset.rental.client_id }
  }"
        icon="fa-external-link-square-alt"
        class="ml-2"
        v-if="fixedAsset.rental && fixedAsset.rental.client_id"
      >
      </ItpLink>
    </ItpBox>
    <ItpButton
      :text="'Add to rental...'|pgettext('FixedAsset')"
      variant="light"
      size="sm"
      v-if="!readonly"
      @click.prevent.stop="evh_1889980785424776_clickPreventStop($event, {})"
    >
    </ItpButton>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcFixedAssetRentalCard extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  fixedAsset!: object;

  @Watch('fixedAsset')
  onFixed_asset(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("fixedAsset")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  ux!: any;
  b_2248226175642056_style!: any;
  dataMembers = ['ux', 'b_2248226175642056_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
        b_2248226175642056_style: {
          minWidth: 0,
        }
        ,
      },
    }
  }

  async act_1889980785424776_emit_6678_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1889980785424776_emit_6678, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_1889980785424776_close_6677_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1889980785424776_close_6677, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_1889980785424776_showModal_6676_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1889980785424776_showModal_6676, alias=undefined
    return {
      name: "AddFixedAssetToRentalModal",
      props: {
        asset: this.fixedAsset,
      }
      ,
    }
  }

  async evh_1889980785424776_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1889980785424776_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1889980785424776_emit_6678: actions.EmitAction;
    evh_1889980785424776_close_6677: actions.EventHandlerImpl;
    act_1889980785424776_showModal_6676: actions.ShowModalAction;
    evh_1889980785424776_clickPreventStop_6675: actions.EventHandlerImpl;
    evh_1889980785424776_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1889980785424776_emit_6678 = new actions.EmitAction(
      {
        actionArgs: this.act_1889980785424776_emit_6678_getActionArgs,
        events: [],
      }
    );
    const evh_1889980785424776_close_6677 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_emit_6678,
        event: "close",
        when: this.evh_1889980785424776_close_6677_getWhen,
        displayName: "emit",
      }
    );
    const act_1889980785424776_showModal_6676 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1889980785424776_showModal_6676_getActionArgs,
        events: [evh_1889980785424776_close_6677],
      }
    );
    const evh_1889980785424776_clickPreventStop_6675 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_showModal_6676,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_1889980785424776_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1889980785424776_clickPreventStop_6675],
      }
    );
    return {
      act_1889980785424776_emit_6678,
      evh_1889980785424776_close_6677,
      act_1889980785424776_showModal_6676,
      evh_1889980785424776_clickPreventStop_6675,
      evh_1889980785424776_clickPreventStop,
    }
  }
}

Vue.component("UcFixedAssetRentalCard", UcFixedAssetRentalCard);

</script>